"use client";

import React, { useContext } from "react";
import Image from "next/image";
import { GlobalContext } from "@/contexts/SiteDataContext";
import { usePathname } from "next/navigation";
import Alert from "@/components/atoms/Alert";
import InfoIcon from "@/components/svgs/info";
import "./styles.scss";

const contactText: Record<string, string> = {
  phone: "Get help <b>online via phone</b>",
  chat: "Get help <b>online vía chat</b>",
  both: "Get help <b>online via phone or chat</b>",
  common: "Our support team is here to help you <b>24/7 via email or form</b>",
};

const ContactCard = () => {
  const {
    t,
    siteDataComplete: { contact_hours },
    siteData: { hasChat, hasPhone, theme },
  } = useContext(GlobalContext).context;

  const copy = hasPhone && hasChat ? "both" : hasPhone ? "phone" : "chat";
  const contactCopy = `${t[contactText[copy]]} ${t[contact_hours]}`;

  const pathname = usePathname();
  const isReviewPage = pathname.includes("/review");
  const isPaymentPage = pathname.includes("/payment");

  return (
    <>
      <div className="contactCard u-box u-box--small">
        <div className="contactCard__body">
          <div className="contactCard__item">
            <Image
              src={`/assets/themes/${theme}/hours.svg`}
              alt="contact-hours"
              width="32"
              height="32"
            />
            <p
              className="contactCard__copy"
              dangerouslySetInnerHTML={{
                __html: t[contactText["common"]],
              }}></p>
          </div>

          <div className="contactCard__item">
            <Image
              src={`/assets/themes/${theme}/stepbystep.svg`}
              alt="contact-method"
              width="32"
              height="32"
            />
            <p
              className="contactCard__copy"
              dangerouslySetInnerHTML={{ __html: contactCopy }}
            />
          </div>
        </div>
      </div>
      {!isReviewPage && !isPaymentPage && (
        <div className="contactCard u-box u-box--small">
          <div className="contactCard__body contactCard__body--alert">
            <p className="contactCard__copy">
              {
                t[
                  "This is a private service not affiliated with any government agency. All fees are for document preparation and support services."
                ]
              }
            </p>
          </div>
        </div>
      )}
    </>
  );
};
export default ContactCard;
